(function (window, document, $) {
  $('select').select2();

  $(document).bind('gform_post_render', function () {
    $('select').select2();
  });
})(window, document, jQuery);
